export default "__VITE_ASSET__42dfdcc8__"